__turbopack_context__.v({
  "container": "PhoneInput-module-scss-module__ALrgpW__container",
  "disabled": "PhoneInput-module-scss-module__ALrgpW__disabled",
  "divider": "PhoneInput-module-scss-module__ALrgpW__divider",
  "dropdown": "PhoneInput-module-scss-module__ALrgpW__dropdown",
  "error": "PhoneInput-module-scss-module__ALrgpW__error",
  "flag": "PhoneInput-module-scss-module__ALrgpW__flag",
  "input": "PhoneInput-module-scss-module__ALrgpW__input",
  "is-open": "PhoneInput-module-scss-module__ALrgpW__is-open",
  "is-selected": "PhoneInput-module-scss-module__ALrgpW__is-selected",
  "item": "PhoneInput-module-scss-module__ALrgpW__item",
  "item-dial": "PhoneInput-module-scss-module__ALrgpW__item-dial",
  "item-flag": "PhoneInput-module-scss-module__ALrgpW__item-flag",
  "item-name": "PhoneInput-module-scss-module__ALrgpW__item-name",
  "trigger": "PhoneInput-module-scss-module__ALrgpW__trigger",
  "trigger-icon": "PhoneInput-module-scss-module__ALrgpW__trigger-icon",
  "wrapper": "PhoneInput-module-scss-module__ALrgpW__wrapper",
});
